import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { CreateSharedDocumentButtonProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { StyledButton } from "components/common";
import useSharedDocumentUploadDialog from "./forms/useSharedDocumentUploadDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CreateSharedDocumentButton: React.FC<CreateSharedDocumentButtonProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { onCreateSuccess } = props;

  const addDocumentDialog = useSharedDocumentUploadDialog(onCreateSuccess);

  const onAddDocumentButtonClick = () => {
    dispatch(displayDialog(addDocumentDialog));
  };

  return (
    <StyledButton size="sm" onClick={onAddDocumentButtonClick}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AddDocument)}
    </StyledButton>
  );
};

export default CreateSharedDocumentButton;
